module.exports = __webpack_public_path__ + "static/media/award.9d83030c.svg";